import React, { lazy, Suspense } from 'react';

// Comps
import Default from '@project-stories/ecommerce/Account/Layouts/Default';
const LoginAndRegister = lazy(() => import('@project-stories/ecommerce/Account/Layouts/LoginAndRegister'));

// Hooks
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';

const layouts = {
    default: Default,
    'login-register': LoginAndRegister
};

export const AccountLanding = ({ section, signUpFields, image, mobileImage, colorSchemas }) => {
    let Layout = layouts[section.layout] || Default;

    // Hooks
    const isMobile = useMobileBreakpoint('767px');
    const imageMobile = mobileImage ? mobileImage : image;

    return (
        <div
            className='bg-parallax'
            style={
                image
                    ? {
                        backgroundImage: `url(${isMobile ? imageMobile.src : image.src})`
                    }
                    : {}
            }
        >
            {/* Overlay */}
            {section.show_overlay && <div className='absolute top-0 left-0 w-full h-full bg-black opacity-50 z-1'></div>}

            <div className='relative flex flex-col md:items-start md:flex-row md:justify-center max-md:gap-y-10 md:gap-x-[81px]'>
                <Suspense>
                    <Layout
                        section={section}
                        signUpFields={signUpFields}
                        headerColorSchema={colorSchemas.header_color_schema}
                    />
                </Suspense>
            </div>
        </div>
    );
};

export default AccountLanding;